import React from "react";
import { ArrowDownIcon, CheckIcon } from "lucide-react";
import { images, volumes } from "../../data/content";
import { SectionHeading } from "../ui/SectionHeading";
import { TransformCta } from "../ui/TransformCta";
export function Volumes() {
  return <section className="bg-brand-50 px-5 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-312" data-mp="2x3cshkdxv7pb">
      <div id="volumes-title" data-id="element-313" data-mp="2t1raxlqgm58s">
        <SectionHeading title={<>
              What's inside <em className="italic text-brand-600" data-id="element-315" data-mp="2o2ep94bbr47s">Reflexology 360°™?</em>
            </>} subtitle="6 premium volumes that take you from the big picture to a practical, repeatable session." data-id="element-314" data-mp="2o0bq9us720qx" />
      </div>

      <img src={images.mainMockup} alt="" className="mx-auto mt-8 w-full max-w-2xl" aria-hidden="true" data-id="element-316" data-mp="29c7gxhf171kt" />

      <div className="mx-auto mt-6 max-w-3xl space-y-6" data-id="element-317" data-mp="25alyzhnn3x3r">
        {volumes.map(vol => <article key={vol.number} className="rounded-3xl bg-white p-6 shadow-sm ring-1 ring-brand-100 sm:p-9" data-id="element-318" data-mp="20ahdtebsee77">
            <div className="flex items-center gap-3" data-id="element-319" data-mp="335dyvabsv077">
              <span className="rounded-full bg-brand-700 px-4 py-1.5 text-sm font-black uppercase tracking-widest text-white" data-id="element-320" data-mp="333t71sgvdvd1">
                Volume {vol.number}
              </span>
            </div>
            <h3 className="mt-4 font-serif text-[1.75rem] font-black leading-tight text-ink sm:text-4xl" data-id="element-321" data-mp="2u34t0xrh7v05">{vol.title}</h3>
            <p className="mt-2 text-lg font-semibold text-brand-700" data-id="element-322" data-mp="3lwdma73nc1yd">{vol.tagline}</p>
            <p className="mt-4 text-[17px] leading-relaxed text-ink/75" data-id="element-323" data-mp="3qv8bprw4corg">{vol.intro}</p>

            {vol.flow && <ol className="mt-5 flex flex-col gap-1.5" aria-label={vol.flowLabel} data-id="element-324" data-mp="3cvyx2wnka2pl">
                {vol.flow.map((step, i) => <React.Fragment key={step} data-id="element-325" data-mp="3ht7fmycmg8rd" data-mpi={i}>
                    <li className="flex items-center gap-3 rounded-xl bg-brand-800 px-4 py-3 text-white" data-id="element-326" data-mp="21ga8y1ykmxn7">
                      <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15 text-sm font-bold" data-id="element-327" data-mp="26f3os11bz0qj">{i + 1}</span>
                      <span className="font-extrabold uppercase tracking-wide" data-id="element-328" data-mp="bxtumj7ll2yo">{step}</span>
                    </li>
                    {i < vol.flow!.length - 1 && <ArrowDownIcon className="mx-auto h-4 w-4 text-brand-500" aria-hidden="true" data-id="element-329" data-mp="72elg4kjbv8l" />}
                  </React.Fragment>)}
              </ol>}

            <p className="mt-6 text-sm font-bold uppercase tracking-wide text-ink/50" data-id="element-330" data-mp="3ub1sczvof793">Inside you'll find</p>
            <ul className="mt-3 grid grid-cols-1 gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-331" data-mp="3pbotthvg0bqo">
              {vol.items.map(item => <li key={item} className="flex items-start gap-2.5 text-[17px] text-ink/85" data-id="element-332" data-mp="3fflwqqfg73al">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cta text-white" data-id="element-333" data-mp="3bejt7xei052t">
                    <CheckIcon className="h-3.5 w-3.5" strokeWidth={3} aria-hidden="true" data-id="element-334" data-mp="1dnh57g1v280e" />
                  </span>
                  {item}
                </li>)}
            </ul>

            {vol.outro && <p className="mt-6 border-t border-brand-100 pt-5 font-serif text-lg font-bold italic leading-snug text-brand-800" data-id="element-335" data-mp="2rk0kd3twda0o">
                {vol.outro}
              </p>}

            {vol.cta && <div className="-mb-2" data-id="element-336" data-mp="31cg3i4gxk4n5">
                <TransformCta label={vol.cta} data-id="element-337" data-mp="35cgfzjkgy5rk" />
              </div>}
          </article>)}
      </div>
    </section>;
}